@if (isAjoutEnabled) {
  <button class="button-add-task" (click)='creerTache()'>
    <i class="icon icon-plus"></i>Ajouter une tâche
  </button>
}

@if (isTachesVisible) {
  <div class="task-container">
    @for (tache of listeTaches; track tache) {
      <div class="liste-item">
        <app-tache [tache]="tache" (editRequested)='editerTache($event)' (tacheMarkedAsFinished)="loadTaches($event)"
          (itemSupprime)="itemSupprime.emit($event)" (requestClosePanel)="close()" [canEdit]="isModifierEnabled"
          [canDelete]="isSupprimerEnabled" [enableRedirections]="isNaviguerEnabled">
        </app-tache>
      </div>
    }
  </div>
}
